var map = {
	"./new/banner_11pick5_gd.jpg": "df8c",
	"./new/banner_11pick5_jx.jpg": "1c57",
	"./new/banner_11pick5_sd.jpg": "7a94",
	"./new/banner_dice.jpg": "5420",
	"./new/banner_dice2.jpg": "7c22",
	"./new/banner_dice_ff.jpg": "5a02",
	"./new/banner_dice_yf.jpg": "7a21",
	"./new/banner_lhs_yf.jpg": "2b85",
	"./new/banner_ompk10.jpg": "2934",
	"./new/banner_pk10.jpg": "cb16",
	"./new/banner_pk10_bj.jpg": "b45d",
	"./new/banner_pk10_yf.jpg": "7458",
	"./new/banner_qq.jpg": "89bf",
	"./new/banner_racing.jpg": "5d71",
	"./new/banner_ssc_chongqing.jpg": "6a54",
	"./new/banner_ssc_cq.jpg": "b5e3",
	"./new/banner_ssc_yf.jpg": "be30",
	"./new/banner_tencent.jpg": "ee27",
	"./new/banner_wechat.jpg": "451e",
	"./new/bg_tab.png": "09be",
	"./new/bg_tab_active.png": "5a77",
	"./new/bg_tab_hover.png": "584a",
	"./new/dice_group_1to6.svg": "7832",
	"./new/footer_machine.png": "d54f",
	"./new/footer_related.png": "5c6f",
	"./new/ic_add_special_num.png": "9b46",
	"./new/ic_add_special_num.svg": "c03f",
	"./new/ic_add_special_num_sm.png": "d711",
	"./new/ic_add_special_num_sm.svg": "304f",
	"./new/ic_dropdown_arrow.svg": "1992",
	"./new/ic_dropdown_arrow_focus.svg": "2121",
	"./new/logo.svg": "cb9c",
	"./new/mobile_menu_control.svg": "0790",
	"./new/number_0.png": "4358",
	"./new/number_1.png": "11df",
	"./new/number_2.png": "9c1f",
	"./new/number_3.png": "fac0",
	"./new/number_4.png": "4cbc",
	"./new/number_5.png": "f71e",
	"./new/number_6.png": "67f8",
	"./new/number_7.png": "f2c8",
	"./new/number_8.png": "baac",
	"./new/number_9.png": "6781",
	"./new/number_bg_blue.png": "b03c",
	"./new/number_bg_gray.png": "d829",
	"./new/number_comma.png": "da85",
	"./new/product_01.png": "bfb4",
	"./new/product_02.png": "9d9a",
	"./new/product_03.png": "433c",
	"./new/qq_about.jpg": "a5ff",
	"./new/tencent_about.jpg": "146e",
	"./new/tencent_data.png": "5251",
	"./new/tencent_tool.jpg": "c202",
	"./new/wechat_about.jpg": "3684",
	"./new/win_ball_blue.png": "20a8",
	"./new/win_ball_green.png": "2fd8",
	"./new/win_ball_red.png": "4ca1",
	"./new/win_bg_01.png": "4615",
	"./new/win_bg_01_l.png": "44ec",
	"./new/win_bg_02.png": "0d47",
	"./new/win_bg_02_l.png": "098a",
	"./new/win_bg_03.png": "b7f0",
	"./new/win_bg_03_l.png": "7b92",
	"./new/win_bg_04.png": "4817",
	"./new/win_bg_04_l.png": "2cf5",
	"./new/win_bg_05.png": "f3c4",
	"./new/win_bg_05_l.png": "c05a",
	"./new/win_bg_06.png": "6559",
	"./new/win_bg_06_l.png": "792d",
	"./new/win_bg_07.png": "53dc",
	"./new/win_bg_07_l.png": "39d7",
	"./new/win_bg_08.png": "4567",
	"./new/win_bg_08_l.png": "d89b",
	"./new/win_bg_09.png": "ea03",
	"./new/win_bg_09_l.png": "c539",
	"./new/win_bg_10.png": "dc31",
	"./new/win_bg_10_l.png": "c2ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";